import { Box, Hidden } from 'braid-design-system';
import type { FC, ReactNode, ReactElement } from 'react';

import AppErrorBoundary from 'src/components/app/AppErrorBoundary';
import {
  jobSectionDomId,
  topOfCandidateListSectionDomId,
} from 'src/stores/JobApplicationStore/utils/scrollToStartOfCandidateList';

export interface AppPageLayoutProps {
  mobileStickyHeader: ReactNode;
  jobSection: {
    boxShadow: 'small' | undefined;
    element: ReactElement;
  };
  pageTabs: ReactNode;
  mobileFilterSection: ReactNode;
  content: ReactNode;
}

export const AppPageLayout: FC<AppPageLayoutProps> = ({
  mobileStickyHeader,
  jobSection,
  pageTabs,
  mobileFilterSection,
  content,
}) => (
  <>
    {mobileStickyHeader}
    <Box
      id={jobSectionDomId}
      width="full"
      background="surface"
      boxShadow={jobSection.boxShadow}
      paddingBottom="large"
    >
      <Box paddingX={['small', 'large']}>
        {/* TODO: Check why we needed this AppErrorBoundary for rendered JobDetails?  */}
        <AppErrorBoundary>{jobSection.element}</AppErrorBoundary>
      </Box>
    </Box>

    {pageTabs}

    <Hidden above="mobile">{mobileFilterSection}</Hidden>

    <div id={topOfCandidateListSectionDomId} />

    <Box>{content}</Box>
  </>
);
